import type { ReactNode } from "react";

interface AuthShellProps {
  children: ReactNode;
  sideTitle?: string;
  sideBody?: string;
}

export function AuthShell({ children, sideTitle, sideBody }: AuthShellProps): JSX.Element {
  return (
    <div className="auth-shell">
      <aside className="auth-shell-side">
        <div className="brand">
          <div className="brand-mark">
            B<span className="dot">.</span>
          </div>
          <div className="brand-name">BestAI FrontDesk</div>
        </div>
        <div>
          <h2>{sideTitle ?? "AI front desk for Kiwi businesses."}</h2>
          <p>
            {sideBody ??
              "Chat, web voice, and phone — one workspace, one knowledge base, trained by your team in plain English."}
          </p>
        </div>
        <div className="help" style={{ fontSize: 11 }}>
          chat.yai.nz · Aotearoa New Zealand
        </div>
      </aside>
      <div className="auth-shell-card-wrap">
        <div className="auth-card">{children}</div>
      </div>
    </div>
  );
}
